// @flow
import React, { Component } from "react";
import moment from "moment";
import Button from "@material-ui/core/Button";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";

import ExportToCsv from "../../../global/functions/ExportCsv";
import {
  isMomentBefore,
  isMomentAfter,
  TodaytoEndTimeAppend
} from "../../../global/functions/DateTimeAmend";
import { propComparator } from "../../../global/functions/StringOperations";

type ExportProjectToCsvPropsType = {
  projects: Array<*>,
  companyFilter?: Array<*>,
  dateStartFilter?: Date | null,
  dateEndFilter?: Date | null
};

class ExportProjectToCsv extends Component<ExportProjectToCsvPropsType, *> {
  render(): * {
    const projects = this.props.projects;

    let csvArray = [
      [
        "Company Name",
        "Deal Name",
        "Pipeline",
        "Deal Type",
        "Milestone",
        "Deal Size",
        "Deal Stage",
        "Close Date",
        "Point of Contact",
        "Contact Number",
        "Contact Email",
        "Distributor",
        "Distributor Point of Contact",
        "Distributor Contact Number",
        "Distributor Contact Email",
        "Reseller",
        "Reseller Point of Contact",
        "Reseller Contact Number",
        "Reseller Contact Email",
        "Notes"
      ]
    ];

    let list = [];
    if (projects) {
      projects.map((project: *, i: number): * => {
        let display = true;
        if (this.props.companyFilter && this.props.companyFilter.length > 0) {
          if (this.props.companyFilter.indexOf(project.createdCompany.id) < 0) {
            display = false;
          }
        }
        if (this.props.dateStartFilter) {
          if (
            isMomentBefore(project.createDateOrigin, this.props.dateStartFilter)
          ) {
            display = false;
          }
        }
        if (this.props.dateEndFilter) {
          if (
            isMomentAfter(project.createDateOrigin, this.props.dateEndFilter)
          ) {
            display = false;
          }
        }

        if (display) {
          list.push(project);
        }
      });

      list.map((item: *): * => {
        const dealType = item.createdCompany.name
          .toLowerCase()
          .includes("imagus")
          ? "Direct"
          : "Channel";

        csvArray.push([
          item.enduserCompany && item.enduserCompany.name,
          item.project_name,
          "",
          dealType,
          "",
          "",
          "",
          moment
            .utc(item.closeDateOrigin)
            .local()
            .format("DD/MM/YYYY"),
          item.enduserCompany && item.enduserCompany.contactName,
          item.enduserCompany && item.enduserCompany.contactNumber,
          item.enduserCompany && item.enduserCompany.contactEmail,
          item.createdCompany.name,
          item.createdCompany.contactName,
          item.createdCompany.contactNumber,
          item.createdCompany.contactEmail,
          item.resellerCompany && item.resellerCompany.name,
          item.resellerCompany && item.resellerCompany.contactName,
          item.resellerCompany && item.resellerCompany.contactNumber,
          item.resellerCompany && item.resellerCompany.contactEmail
        ]);
      });

      const fileName = `project-list-${new Date(Date.now()).toLocaleString()}`;

      return (
        <Button
          type="button"
          variant="contained"
          color="primary"
          className="dark-btn"
          onClick={(): Function => ExportToCsv(fileName, csvArray)}
        >
          <CloudDownloadIcon className="light-icon right-margin-5" />
          Export to CSV
        </Button>
      );
    } else {
      return null;
    }
  }
}

export default ExportProjectToCsv;
